/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RegisterStandaloneActionButtonsComponent } from '../action-buttons/action-buttons.component';
import { RegisterStandaloneService } from '../register-standalone.service';
import { catchError, of, throwError } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { DebugService } from 'src/app/services/debug.service';
import { SurveyComponent } from '../../new-survey/new-survey.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'cicerone-register-step-user-data',
  templateUrl: './step-user-data.component.html',
  styleUrls: ['./step-user-data.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    RegisterStandaloneActionButtonsComponent
  ]
})
export class RegisterUserStandaloneDataComponent {
  private debugService = inject(DebugService);
  
  @Output() formActionEmiter: EventEmitter<any> = new EventEmitter<any>();
  private modalController = inject(ModalController);
  private registerStandaloneService = inject(RegisterStandaloneService);
  private translate = inject(TranslateService);
  private formBuilder = inject(FormBuilder);
  userData: FormGroup;
  surveyModal: any;

  constructor() {
    this.userData = this.formBuilder.group({ 
      name: ['', [Validators.required,  Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]]
    });
  }

  get f() { return this.userData.controls; }

  onSubmit(){
    if (!this.userData.valid) 
      return;

    const user = { name: this.userData.get('name')?.value, email: this.userData.get('email')?.value}
    this.registerStandaloneService.setUserData(user);

    this.registerStandaloneService.sendRegisterData()
      .pipe(
          catchError((error) => {
              this.showError();
              return throwError(() => new Error('HTTP request failed', { cause: error }));
          })
      )
      .subscribe((res: any) => {
        this.debugService.debug(res, '[StepUserDataComponent] Register API Response');

        const routeId = res.register_id;
        if (res.status === 'Success'){
          Swal.fire({
              title: '',
              text: this.translate.instant(`Registro enviado correctamente`),
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK',
              timer: 2500,
              timerProgressBar: true,
          }).then((result) => {
              this.checkIfSurvey(routeId)
          })
          return;
        }
        this.showError();
        
      })
  }

  async checkIfSurvey(registerId) {
      if (!registerId || !this.registerStandaloneService.surveyQuestion()){
        location.reload();
        return;
      }

      this.surveyModal = await this.modalController.create({
          component: SurveyComponent,
          cssClass: 'surveyModal',
          componentProps: { 
            registerID: registerId, 
            surveyModal: this.registerStandaloneService.surveyQuestion(), 
            isModal: true 
          }
      });
      await this.surveyModal.present();
      await this.surveyModal.onDidDismiss();
      location.reload();
  }

  showError(){
    Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Ha ocurrido un error al enviar el registro`) })
  }

  formAction(event){
    if (event === 'next')
      this.onSubmit()

    if (event === 'back')
        this.formActionEmiter.emit('back')
  }

}
